import Vue from 'vue'
import Router from 'vue-router'
/*import Home from './views/Home.vue'
import Menu from './views/Menu.vue'
import VistaPedido from './views/VistaPedido.vue'
import VistaFacturas from './views/VistaFacturas.vue'
import VistaRutas from './views/VistaRutas.vue'
import VistaPass from './views/VistaPass.vue'
import facturasPendientes from './components/facturasPendientes.vue'*/

Vue.use(Router)

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      //component: Home
      component: lazyLoad('Home')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/menu',
      name: 'menu',
      //component: Menu
      component: lazyLoad('Menu')
    },
    {
      path: '/pedido',
      name: 'pedido',
      //component: VistaPedido
      component: lazyLoad('VistaPedido')
    },
    {
      path: '/facturas',
      name: 'facturas',
      //component: VistaFacturas
      component: lazyLoad('VistaFacturas')
    },
    {
      path: '/rutas',
      name: 'rutas',
      //component: VistaRutas
      component: lazyLoad('VistaRutas')
    },
    {
      path: '/restorePass',
      name: 'restorePass',
      //component: VistaPass
      component: lazyLoad('VistaPass')
    },
    {
      path: '/test',
      name: 'test',
      //component: facturasPendientes
      component: lazyLoad('facturasPendientes')
    }
  ]
})
